import {  Component, Vue } from "vue-property-decorator"
import { financeCommissionStatisticalData, financeCommissionStatisticalDataExport } from '@/api/financial-center'
import { delNullProperty } from '@/utils/index'
import { formatDate } from '@/utils/timeFilter'

@Component({})
export default class OrderStatisticsData extends Vue {

  page = 1
  limit = 20
  total = 0
  dissertationType = ''
  souCourseName = ''
  souCourseSchoolBegin = []
  tableData = []
  tableLoading = false
  popover1 = false
  popover2 = false
  popover3 = false
  exportButtonDisabled = false
  exportHeaderDialogVisible = false
  tableHeader: any = [
    { filds: 'customerName', cnFilds: '客户名称', isShow: true, id: 1 },
    { filds: 'souCourseName', cnFilds: '项目名称', isShow: true, id: 2 },
    { filds: 'souCourseType', cnFilds: '项目类型', isShow: true, id: 3 },
    { filds: 'souCourseSchoolBegin', cnFilds: '开课时间', isShow: true, id: 4 },
    { filds: 'marketCooperationName', cnFilds: '合作伙伴名称', isShow: true, id: 5 },
    { filds: 'marketCooperationTypes', cnFilds: '合作伙伴类型', isShow: true, id: 6 },
    { filds: 'price', cnFilds: '返佣金额', isShow: true, id: 7 },
    { filds: 'extraPrice', cnFilds: '额外佣金', isShow: true, id: 8 },
    { filds: 'code', cnFilds: '返佣编号', isShow: true, id: 9 },
    { filds: 'financeOrderCode', cnFilds: '订单编号', isShow: true, id: 10 },
    { filds: 'ratio', cnFilds: '返点比例', isShow: true, id: 11 },
    { filds: 'financeOrderPrice', cnFilds: '订单金额', isShow: true, id: 12 },
    { filds: 'financeOrderCreatedUserRealName', cnFilds: '订单创建人', isShow: true, id: 13 },
    { filds: 'customerDirectorUserRealName', cnFilds: '客户负责人', isShow: true, id: 14 },
    { filds: 'financeCommissionCreatedUserRealName', cnFilds: '返佣创建人', isShow: true, id: 15 },
  ]
  code = ''
  financeOrderCode = ''
  types = ''
  customerName = ''
  marketCooperationName = ''
  timer = null
  // isReadonly = false

  created() {
    this.getTableData()
  }

  async getTableData() {
    this.popover1 = false
    this.popover2 = false
    this.popover3 = false
    this.tableLoading = true

    const { allNum, financeCommissionDetailList} = await financeCommissionStatisticalData(delNullProperty({
      limit: this.limit,
      page: this.page,
      code : this.code,
      financeOrderCode : this.financeOrderCode,
      customerName : this.customerName,
      marketCooperationName : this.marketCooperationName,
    })) as unknown as { allNum: number; financeCommissionDetailList: any[] }
    this.tableData = financeCommissionDetailList
    this.total = allNum
    this.tableLoading = false
    // this.isReadonly = false
  }

  async exportExcel(keys: string = '') {
    this.exportButtonDisabled = true
    const obj = {
      code: this.code,
      financeOrderCode: this.financeOrderCode,
      customerName: this.customerName,
      marketCooperationName: this.marketCooperationName,
      keys,
    }
    await financeCommissionStatisticalDataExport(delNullProperty(obj)
    )
    this.$message.success('数据已转入后台导出, 请前往下载列表查看')
    this.exportButtonDisabled = false
  }

  pageChange(page: number) {
    if (this.timer !== null) clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.page = page
      this.getTableData()
    }, 1000)
  }

  pageSizeChange(limit: number) {
    this.limit = limit
    this.getTableData()
  }

}
